import React from 'react';
import './Onboarding.css';
import AmbientStage from '../components/AmbientStage';
import RotatingDisc from '../components/RotatingDisc';
import logo from '../assets/logo.png';
import heroImg from '../assets/heroimg.png';
import fabricImg from '../assets/fabric.png';
import arrowIcon from '../assets/arrow.png';

const stats = [
  { value: '342', label: 'Exhibitors' },
  { value: '45', label: 'Countries' },
  { value: '8.5K+', label: 'Visitors' },
];

function Onboarding({ goNext }) {
  return (
    <AmbientStage className="onboarding-screen">
      <div className="top-brand compact">
        <img src={logo} alt="Exhibition logo" />
        <button onClick={goNext} type="button">Skip</button>
      </div>

      <div className="motion-poster">
        <span className="poster-frame" />
        <img className="poster-img poster-one" src={fabricImg} alt="Textile machine" />
        <img className="poster-img poster-two" src={heroImg} alt="Colorful fabric samples" />
        <RotatingDisc label="Live Map" detail="Hall A-C" />
      </div>

      <div className="copy-block">
        <p className="eyebrow">Step into the floor</p>
        <h2>Follow the energy, not the crowd.</h2>
        <p>
          Swipe through zones, save live demos, and let the app guide you like a
          moving exhibition poster in your hand.
        </p>
      </div>

      <div className="mini-stats">
        {stats.map((stat) => (
          <article key={stat.label}>
            <strong>{stat.value}</strong>
            <span>{stat.label}</span>
          </article>
        ))}
      </div>

      <button className="gold-action full" onClick={goNext} type="button">
        Start Journey
        <img src={arrowIcon} alt="" aria-hidden="true" />
      </button>
    </AmbientStage>
  );
}

export default Onboarding;
